<script src="../../general/floor-page/floor-page.component.ts"></script>
<script src="edit-job.component.ts"></script>
<div class="py-4">
  <mat-card-header class="flex align-items-center">
    <shared-title>
      @if (issParking() === 1) {
        Información del parqueo
      } @else {
        Información del puesto de trabajo
      }
    </shared-title>
    <button
      (click)="clearForm()"
      mat-icon-button
      matTooltip="Limpiar formulario"
      matTooltipPosition="right"
      class="ml-5">
      <mat-icon>cleaning_services</mat-icon>
    </button>
  </mat-card-header>

  <mat-card-content class="mt-5">
    <form [formGroup]="formEditJob" (ngSubmit)="sumit()">
      <div class="grid">
        <div
          class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
          <shared-input
            class="w-full"
            [labelTitle]="'Nombre'"
            [control]="$any(formEditJob.get('name'))" />
        </div>

        <div
          class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row"
          style="margin-bottom: 18px">
          <shared-input
            class="w-full"
            [labelTitle]="'Descripción'"
            [control]="$any(formEditJob.get('description'))" />
          <shared-input
            class="w-full"
            [labelTitle]="'Teléfono'"
            [control]="$any(formEditJob.get('phone'))" />
        </div>

        <mat-form-field class="col-6" appearance="outline">
          <mat-label> Coordenada X</mat-label>
          <input matInput formControlName="x" />
        </mat-form-field>

        <mat-form-field class="col-6" appearance="outline">
          <mat-label>Coordenada Y</mat-label>
          <input matInput formControlName="y" />
        </mat-form-field>

        <mat-form-field class="col-6" appearance="outline">
          <mat-label>Tipo de puesto de trabajo</mat-label>
          <mat-select matInput formControlName="workplacetypeid">
            @for (item of ptypeJobs; track item) {
              <mat-option [value]="item.workplacetypeid">{{
                item.name
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field class="col-6" appearance="outline">
          <mat-label>Grupo de lugar de trabajo</mat-label>
          <mat-select matInput formControlName="workplaceGroupId">
            @for (group of workplaceGroups; track group) {
              <mat-option [value]="group.id">{{ group.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-label class="col-12 text-center">
          @if (issParking() === 1) {
            Día en los que esta disponible este parqueo:
          } @else {
            Día en los que esta disponible este puesto de trabajo:
          }
        </mat-label>
        <mat-selection-list class="col-12 text-center">
          <div class="day-checkboxes">
            <div class="checkbox-item text-center">
              <mat-checkbox
                formControlName="monday"
                [checked]="lunes"></mat-checkbox>
              <span>L</span>
            </div>
            <div class="checkbox-item text-center">
              <mat-checkbox
                formControlName="tuesday"
                [checked]="martes"></mat-checkbox>
              <span>M</span>
            </div>
            <div class="checkbox-item text-center">
              <mat-checkbox
                formControlName="wednesday"
                [checked]="miercoles"></mat-checkbox>
              <span>M</span>
            </div>
            <div class="checkbox-item text-center">
              <mat-checkbox
                formControlName="thursday"
                [checked]="jueves"></mat-checkbox>
              <span>J</span>
            </div>
            <div class="checkbox-item text-center">
              <mat-checkbox
                formControlName="friday"
                [checked]="viernes"></mat-checkbox>
              <span>V</span>
            </div>
            <div class="checkbox-item text-center">
              <mat-checkbox
                formControlName="saturday"
                [checked]="sabado"></mat-checkbox>
              <span>S</span>
            </div>
            <div class="checkbox-item text-center">
              <mat-checkbox
                formControlName="sunday"
                [checked]="domingo"></mat-checkbox>
              <span>D</span>
            </div>
          </div>
        </mat-selection-list>
        @if (issParking() === 1) {
          <div
            class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
            <mat-selection-list class="col-12">
              <mat-label>
                Reservar parqueo para un usuario en especifico.
              </mat-label>
            </mat-selection-list>
          </div>

          <div
            class="w-full gap-1 flex flex-column justify-content-center align-content-left">
            <mat-form-field class="col-10" appearance="outline">
              <mat-label>Clientes con parqueo</mat-label>
              <mat-select formControlName="assignedWorker">
                @for (item of workerisparking(); track item) {
                  <mat-option [value]="item.workerId">
                    {{ item.firstName }} {{ item.lastName }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div
            class="w-full gap-1 flex flex-column justify-content-center align-content-left">
            <section>
              <mat-label>
                Rango de fechas en que estará libre el parqueo
              </mat-label>
              <mat-form-field class="col-10" appearance="outline">
                <mat-label>Ingrese el rango de fechas</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                  <input
                    matStartDate
                    formControlName="startDate"
                    placeholder="Fecha de inicio" />
                  <input
                    matEndDate
                    formControlName="endDate"
                    placeholder="
                    Fecha final" />
                </mat-date-range-input>
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
            </section>
          </div>
        }
      </div>
    </form>
  </mat-card-content>
  <mat-dialog-actions class="flex justify-content-evenly pb-6">
    <shared-button
      class="flex"
      mat-dialog-close
      [icon]="'clear'"
      [typeBtn]="'button'"
      [color]="'warn'"
      >Cancelar
    </shared-button>
    <shared-button
      class="flex"
      (click)="editJob()"
      [disabled]="!formEditJob.valid"
      [icon]="'create'"
      [typeBtn]="'button'"
      [color]="'accent'"
      >Guardar
    </shared-button>
  </mat-dialog-actions>
</div>
